import {Component, Input} from "@angular/core";

@Component({
    selector: 'app-sanierung-help-callout',
    templateUrl: './sanierung-help-callout.component.html',
    standalone: false
})
export class SanierungHelpCalloutComponent {
  @Input() toggles: {[key: string]: boolean};

  @Input() toggleName: string;

  @Input() textkey: string;
}
